import React from 'react'
import {   FormPro } from '@roo/roo'
import  Radio from '@roo/roo/Radio'
import  Selector from '@roo/roo/Selector'
import { useTranslation } from '@sailor/i18n-web'
import { FormInstance } from '@roo/roo/FormPro'
import {   BudgetFeeTypeFeEnum, StaffStatusEnum } from '../utils'
import { useRequest } from 'ahooks'
import {  fetchBalanceBatchList } from '../utils/api'
import useRuleConfig from '@/common/recoil/atom/ruleConfigAtom'
import BudgetFormItems from './BudgetFormItems'

const subFormItemLayout = {
  labelCol: { span: 0 },
  wrapperCol: { span: 9 },
}

/** 下发方式i */
const IssuanceFormItems = (props: { form: FormInstance, isCreate: boolean}) => {
  const { form } = props
  const { t } = useTranslation()
  const formIssuanceType = FormPro.useWatch('budgetFeeType', form)
  const ruleConfig = useRuleConfig()

  const radioConfig = [
    {
      value: BudgetFeeTypeFeEnum.BATCH,
      disabled: ruleConfig?.budgetFeeConfig?.useWallet === false,
      label: t('e_pc_batch_issuance', '批次下发'),
    },
    {
      value: BudgetFeeTypeFeEnum.BUDGET_LOOP,
      disabled: ruleConfig?.budgetFeeConfig?.useBudget === false,
      label: t('e_pc_cycle_issuance', '循环下发'),
    },
    {
      value: BudgetFeeTypeFeEnum.BUDGET_ONCE,
      disabled: ruleConfig?.budgetFeeConfig?.useBudget === false,
      label: t('e_pc_one_time_issuance', '一次性下发'),
    },
  ].filter(item => !item.disabled)


  return (
    <>
      <FormPro.Item label={t('e_pc_issuance_method', '下发方式')} name="budgetFeeType" required
        rules={[{ required: true, message: t('e_pc_issuance_method_placeholder', '请选择下发方式') }]}
      >
        <Radio.Group disabled={!props.isCreate}>
          {radioConfig.map(item => (
            <Radio key={item.value} value={item.value} >{item.label}</Radio>
          ))}
        </Radio.Group>
      </FormPro.Item>
      <FormPro.Item needLabel >
        <div style={{ paddingLeft: '16px' }}>
          {formIssuanceType === BudgetFeeTypeFeEnum.BATCH && (<BatchFormItems/>)}
          {[BudgetFeeTypeFeEnum.BUDGET_LOOP, BudgetFeeTypeFeEnum.BUDGET_ONCE].includes(formIssuanceType) && (<BudgetFormItems form={form} isCreate={props.isCreate}/>)}
        </div>
      </FormPro.Item>
    </>
  )
}

/** 批次下发 */
const BatchFormItems = () => {
  const { t } = useTranslation()
  const { data: balanceBatchListRes } = useRequest(() => fetchBalanceBatchList({ pageNo: 1, pageSize: 200 }))
  return (
    <>
      <FormPro.Item label={t('e_pc_balance_batch', '余额批次')} name="batchNoList"
        {...subFormItemLayout}

      >
        <Selector multiple clearable  filterable filterMethod
          options={balanceBatchListRes?.result?.map(item => ({ label: item.batchName, value: item.batchNo }))}
          placeholder={t('e_pc_select_balance_batch', '选择余额批次')}
          rawOption // NOTE: 依赖该属性选中整个option,否则回填会有问题
        />
      </FormPro.Item>
      <FormPro.Item label={t('e_pc_apply_status', '适用状态')} name="staffStatus"
        {...subFormItemLayout}
      >
        <Radio.Group >
          <Radio value={StaffStatusEnum.NO_LIMIT}>{t('e_pc_no_status_limit', '不区分状态')}</Radio>
          <Radio value={StaffStatusEnum.IN_JOB}>{t('e_pc_employed', '在职')}</Radio>
          <Radio value={StaffStatusEnum.DIS_MISSION}>{t('e_pc_leave', '离职')}</Radio>
        </Radio.Group>
      </FormPro.Item>
    </>
  )
}


export default IssuanceFormItems